<nav
  class="rtl md:right-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-blueGray-800 flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
>
  <div
    class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
  >
    <!-- Brand -->
    <a [routerLink]="['/doctor-panel/dashboard']" 
      class="flex text-right md:pb-2 text-white mr-0 cursor-pointer text-2xl uppercase z-100 font-semibold p-4 px-0">
      <img src="../../../assets/img/Ostadvisit-Logo.svg" class="w-10" alt="">
      <span class="block sm:hidden m-2"> استاد ویزیت </span>
      <span class="hidden sm:block m-2">  استاد ویزیت</span>
    </a>
    <!-- Toggler -->
    <button
      class="cursor-pointer text-white opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
      type="button"
      (click)="toggleCollapseShow('bg-blueGray-800 m-2 py-3 px-6')"
    >
      <i class="fas fa-bars"></i>
    </button>
    <!-- User -->
    <!-- <ul class="md:hidden items-center flex flex-wrap list-none">
      <li class="inline-block relative">
        <app-notification-dropdown class="block"></app-notification-dropdown>
      </li>
      <li class="inline-block relative">
        <app-user-dropdown class="block"></app-user-dropdown>
      </li>
    </ul> -->
    <!-- Collapse -->
    <div
      class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
      [ngClass]="collapseShow"
    >
      <!-- Collapse header -->
      <div
        class="md:min-w-full md:hidden block pb-4 mb-4 border-solid border-blueGray-200">
        <div class="flex flex-wrap">
          <div class="w-6/12">
            <!-- <a
              href="https://ostadvisit.com/" target="_blank"
              class="md:block text-left md:pb-2 text-white mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            >
              استاد ویزیت
            </a> -->
          </div>
          <div class="w-6/12 flex justify-end">
            <button
              type="button"
              class="cursor-pointer text-white opacity-50 md:hidden mt-5 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              (click)="toggleCollapseShow('hidden')"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="my-4 md:min-w-full" />
      <!-- Navigation -->

      <ul class="md:flex-col md:min-w-full flex flex-col list-none">
        <li class="items-center"><a [routerLink]="['/doctor-panel/account']"
          class="text-lg uppercase p-4 font-bold rounded-lg flex"
          routerLinkActive (click)="toggleCollapseShow('hidden')"
          #userAccount="routerLinkActive"
          [ngClass]="
            userAccount.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="userAccount.isActive?'../../../assets/img/icon/doctor.svg':'../../../assets/img/icon/doctor_outline.svg'" alt="">
            حساب کاربری </a></li>
          <li class="items-center"><a [routerLink]="['/doctor-panel/doctor-calendar']"
              class="text-lg uppercase p-4 font-bold flex rounded-lg"
              routerLinkActive (click)="toggleCollapseShow('hidden')"
              #calendar="routerLinkActive"
              [ngClass]="
                calendar.isActive
                  ? 'text-primary hover:text-primary bg-primary-light'
                  : 'text-white hover:text-blueGray-500'
              ">
                <img class="px-2 mx-1 w-10" [src]="calendar.isActive?'../../../assets/img/icon/Calendar.svg':'../../../assets/img/icon/Calendar_outline.svg'" alt="">
                برنامه پزشک </a>
        <li class="items-center"><a [routerLink]="!isDoctor?null:['/doctor-panel/appointment']"
          class="text-lg uppercase p-4 font-bold flex rounded-lg"
          routerLinkActive (click)="toggleCollapseShow('hidden')"
          #userAppointment="routerLinkActive"
          [ngClass]="
            userAppointment.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="userAppointment.isActive?'../../../assets/img/icon/Document.svg':'../../../assets/img/icon/Document_outline.svg'" alt="">
            ویزیت ها </a>
        </li>
        <li class="items-center"><a [routerLink]="!isDoctor?null:['/doctor-panel/wallet']"        
          class="text-lg uppercase p-4 font-bold rounded-lg flex"
          routerLinkActive (click)="toggleCollapseShow('hidden')"
          #userWallet="routerLinkActive"
          [ngClass]="
            userWallet.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="userWallet.isActive?'../../../assets/img/icon/Wallet.svg':'../../../assets/img/icon/Wallet_outline.svg'" alt="">
            مدیریت مالی </a></li>
        <li class="items-center"><a [routerLink]="!isDoctor?null:['/doctor-panel/message']"
            class="text-lg uppercase p-4 font-bold flex rounded-lg"
            routerLinkActive (click)="toggleCollapseShow('hidden')"
          #message="routerLinkActive"
          [ngClass]="
            message.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="message.isActive?'../../../assets/img/icon/chat.svg':'../../../assets/img/icon/chat_outline.svg'" alt="">
            پیام ها </a></li>
        <li class="items-center"><a routerlinkactive=""  (click)="modal.open();toggleCollapseShow('hidden')"
            class="text-lg uppercase p-4 font-bold flex text-white hover:text-blueGray-500 cursor-pointer">
            <img class="px-2 mx-1 w-10" src="../../../assets/img/icon/Logout_outline.svg" alt="">
            خروج </a></li>
      </ul>



      <!-- <ul class="md:flex-col md:min-w-full flex flex-col list-none">
        <li class="items-center">
          <a
            [routerLink]="['/admin/dashboard']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminDashboard="routerLinkActive"
            [ngClass]="
              adminDashboard.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-tv mr-2 text-sm"
              [ngClass]="
                adminDashboard.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Dashboard
          </a>
        </li>

        <li class="items-center">
          <a
            [routerLink]="['/admin/settings']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminSettings="routerLinkActive"
            [ngClass]="
              adminSettings.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-tools mr-2 text-sm"
              [ngClass]="
                adminSettings.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Settings
          </a>
        </li>

        <li class="items-center">
          <a
            [routerLink]="['/admin/tables']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminTables="routerLinkActive"
            [ngClass]="
              adminTables.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-table mr-2 text-sm"
              [ngClass]="
                adminTables.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Tables
          </a>
        </li>

        <li class="items-center">
          <a
            [routerLink]="['/admin/maps']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminMaps="routerLinkActive"
            [ngClass]="
              adminMaps.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-map-marked mr-2 text-sm"
              [ngClass]="
                adminMaps.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Maps
          </a>
        </li>
      </ul> -->

    </div>
  </div>
</nav>



<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      خروج  
    </h3>
    <button class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto">
    <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
      آیا قصد دارید از پنل پزشک خارج شوید؟
    </p>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-t border-solid border-blueGray-200 rounded-b">
    <button class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150" type="button" (click)="modal.close()">
      انصراف
    </button>
    <button class="bg-red-500 text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150" type="button" (click)="logout()">
      خروج
    </button>
  </div>
</app-modal>

